import { render, staticRenderFns } from "./Dropdown.vue?vue&type=template&id=b054022a&"
import script from "./Dropdown.vue?vue&type=script&lang=ts&"
export * from "./Dropdown.vue?vue&type=script&lang=ts&"
import style0 from "./Dropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports